
import Card from './gallery/Card';
import styled from 'styled-components'

function Gallery() {
  const categories = [
    {
      id: 1,
      title: 'Culture',
      path: '/gallery/cultural-activities',
    },
    {
      id: 2,
      title: 'Sports',
      path: '/gallery/sports-activities',
    },
    {
      id: 3,
      title: 'Achievements',
      path: '/gallery/achievements',
    },
    // {
    //   id: 4,
    //   title: 'News Articles',
    //   path: '/gallery/news-articles',
    // },
  ];

  return (
    <Wrapper>
      <div className="container">
        {categories.map((category) => (
          <Card key={category.id} {...category} />
        ))}
      </div>
    </Wrapper>


  )
}
const Wrapper = styled.section`
.container{
  margin-top:200px;
  display: grid !important;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  justify-content: center;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    width: fit-content;
    margin: 180px auto;
  }
}   
`
export default Gallery